import { z } from 'zod';
import { LEVELS, ROLES, CATEGORIES, define, DEFINITION_KINDS } from '../types.js';

/**
 * Label for reference number field.
 */
export const schema = z.string();

export type ReferenceNumLabel = z.infer<typeof schema>;

export const definition = define({
  key: 'reference_num_label',
  schema,
  label: 'Reference ID Label',
  description:
    'A client-specific label to display for the reference number field (e.g. "RO Number", "Claim Number", "Fleet ID", etc.).',
  kind: DEFINITION_KINDS.SETTING,
  category: CATEGORIES.REFERENCE_NUMBER.key,
  writableAtLevels: [LEVELS.HOPDRIVE, LEVELS.ORGANIZATION, LEVELS.CUSTOMER],
  readableByRoles: [ROLES.ADMIN],
  defaultValue: 'Reference ID',
});
